import { render, staticRenderFns } from "./receiveTransfers.vue?vue&type=template&id=0db40312&"
import script from "./receiveTransfers.vue?vue&type=script&lang=js&"
export * from "./receiveTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports